import React from 'react';

import { Text } from '../atom/Text';
import { Button } from '../atom/Button';
import { Flex } from '../atom/Layout';
import { TextLink } from '../molecules/TextLink';
import { InputForm } from '../organism/InputForm';
import PageTemplate from './PageTemplate';

import { useHistory } from 'react-router-dom';
import * as PATH from '../../../lib/routes/path';
import { ArrowToggleLogin } from '../organism/Toggle';
import { NaverLoginButton } from '../molecules/NaverLoginButton';
import { babyface } from '../../../lib/image/CDNUrl';
import { NotiIconImage } from '../atom/NotiIconImage';
import styled from 'styled-components';

const HeSigninTemplate = ({
  state,
  onChangeValue,
  onValidate,
  onSignin,
  isValidateTrue,
  isLoading,
}) => {
  const history = useHistory();

  return (
    <PageTemplate title={PAGE_TITLE}>
      <div style={{ marginBottom: '1.5rem' }}>
        <Text
          size={16}
          lineHeight={1.5}
        >
          먼저, 입체초음파로 태아의 얼굴을 촬영합니다.<br />
          숙련된 방사선사 선생님이 클리어페이스를 활용해 입체초음파 영상을 더욱 선명하고 또렷하게 만들어주실 거에요. <br /><br />
          분석이 완료되면 클리어페이스를 다운로드 받을 수 있습니다. <br /><br />
          간편 회원가입 클릭 한번으로 확인해보세요!<br />
        </Text>
      </div>
      <div style={{ height: '1.8rem', textAlign: 'center' }}>
        <NotiIconImage
          src={`${babyface}/signup/kakao_login_noti_icon.png`}
          alt="간편 로그인 안내 아이콘"
        />
      </div>
      <NaverLoginButton />
      <ArrowToggleLogin title="로그인 방법 더보기" style={{ padding: '1.25rem 0' }}>
        <Flex column alignItems="strecth" style={{ width: '100%' }}>
          <Text size="12" textAlign="center" style={{ marginBottom: '0.5rem' }}>이메일로 로그인하기</Text>
          <InputForm
            state={state}
            formData={SIGNIN_DATA}
            onChangeValue={onChangeValue}
            onValidate={onValidate}
            onSubmit={onSignin}
            size={3}
          >
            <Flex padding="0.313rem 0 1.25rem" justifyContent="flex-end">
              <TextLink link={PATH.FIND} size="12" color="brownGrey">
                아이디/비밀번호를 잊어버리셨나요?
              </TextLink>
            </Flex>
            <Button
              style={{ height: '2.595rem' }}
              onClick={onSignin}
              isLoading={isLoading}
              color={isValidateTrue ? 'orangePink' : 'pinkishGrey'}
            >
              {SUBMIT_BUTTON}
            </Button>
            <SignupButton
              style={{ height: '2.595rem', marginTop: '1.25rem' }}
              onClick={() => history.push(PATH.HE_SIGNUP)}
              >
              {SIGNUP_BUTTON}
            </SignupButton>
          </InputForm>
        </Flex>
      </ArrowToggleLogin>
    </PageTemplate>
  );
};

export default React.memo(HeSigninTemplate);

const PAGE_TITLE = '로그인 | 회원가입';
const SUBMIT_BUTTON = '로그인';
const SIGNUP_BUTTON = '회원가입';
const SIGNIN_DATA = [
  {
    mainIconName: 'email',
    subIconName: null,
    placeholder: '예) babyface@babyface.com',
    type: 'email',
    name: 'email',
  },
  {
    mainIconName: 'lock',
    subIconName: 'visibility',
    placeholder: '예) babyFace123@',
    type: 'password',
    name: 'password',
  },
];

const SignupButton = styled(Button)`
  border: ${(props) =>
    `1px solid ${props.theme.color.orangePink}`};
  border-radius: 0.375rem;
  background: ${(props) => props.theme.color.background};
  color: ${(props) => props.theme.color.orangePink};
`;